import { flow, types, Instance } from 'mobx-state-tree';
import { getEnvironment } from './utils';
import * as signalR from '@microsoft/signalr';
import config from '../config';
import { any } from 'glamor';
import { compose } from 'mobx-state-tree/dist/internal';

export const PushNotificationStore = types
  .model('PushNotificationStore', {
    userCount: types.integer,
    sessionList: types.array(types.model({ value: types.string, label: types.string })),
    message: types.string,
    planningSaved: types.boolean,
    score: types.string
  })
  .actions((self) => {
    const env = getEnvironment(self);
    let hubConnection = {};

    const receiveUserCount = (userCount: number) => {
      self.userCount = userCount;
    };

    const receiveSessions = (sessions: any) => {
      // console.log(JSON.stringify(sessions));
      // console.log("Liste des sessions--------------");
      for (var key in sessions) {
        if (sessions.hasOwnProperty(key)) {
            /* useful code here */
            // console.log(sessions[key].user);
        }
      }
      // console.log("Fin--------------");
      self.sessionList.clear();
      Object.values(sessions).map((item:any) => {
        if (item.user != null) self.sessionList.push({ value:item.user as string, label:item.user as string });
      });
      console.log(self.sessionList);
      self.userCount = self.sessionList.length;
      console.log("User count "+ self.userCount);
    };

    const push = flow(function*(message: string) {
      const res = yield env.api.post('pushNotif', { message: message });
    });

    return {
      getConnection() {
        if (!hubConnection) {
          hubConnection = new signalR.HubConnectionBuilder().withUrl(config.hubUrl).build();
        }
        return hubConnection;
      },
      connect(user: string) {
        // console.log(config.hubUrl);
        const hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(config.hubUrl)
          .withAutomaticReconnect()
          .build(); // 'http://localhost:5001/pharmagardeHub').build();
        hubConnection.on('ReceiveMessage', this.receiveMessage);
        hubConnection.on('ReceiveUserCount', this.receiveUserCount);
        hubConnection.on('ReceiveSessions', this.receiveSessions);
        hubConnection.on('ReceivePlanningSaved', this.receivePlanningSaved);
        hubConnection.on('PushScore', this.receiveScore);

        hubConnection
          .start()
          .then(() => {
            hubConnection.send('onRegisterUser', [user])
            .then(() => {
              console.log('user registered');
            })
            .catch(err => console.log(err));
            return console.log('SignalR connected');
          })
          .catch(err => console.log(err));
      },
      planningSaveStart() {
        self.planningSaved = false;
      },
      receiveMessage(user, message) {
        const msg = message
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        const encodedMsg = user + ' says ' + msg;
        self.message = encodedMsg;
      },
      receiveUserCount,
      receiveSessions,
      receivePlanningSaved() {
        self.planningSaved = true;
      },
      receiveScore(user, score) {
        self.score = score.hardScore + " " + score.mediumScore + " " + score.softScore;
      },
      push,
      displayMessage(message) {
        self.message = message
      }
    };
  });
